import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient";

export default function ActivateOrganisation() {
  const { token } = useParams();
  const [message, setMessage] = useState("⏳ Activating your account...");

  useEffect(() => {
  //  console.log("Activating account with token:", token);
    apiClient
      .get(`/api/organisationactivation/${token}`)
      .then((res) => {
        setMessage(`🎉 ${res.data.message}`);
      })
      .catch((err) =>
        setMessage(`❌ ${err.response?.data?.message || "Something went wrong"}`)
      );
  }, [token]);

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f0f4ff, #e6f7ff)",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          padding: "40px",
          borderRadius: "20px",
          background: "#fff",
          boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
          textAlign: "center",
          maxWidth: "400px",
        }}
      >
        <h2 style={{ fontSize: "1.8rem", color: "#333" }}>{message}</h2>
        {message.includes("successfully") && (
          <p style={{ fontSize: "1.2rem", color: "green" }}>✅ You can now login.</p>
        )}
        {message.includes("wrong") && (
          <p style={{ fontSize: "1.2rem", color: "red" }}>⚠️ Please try again later.</p>
        )}
      </div>
    </div>
  );
}
